
















































































































































































































































































































































































































































































































































































































































































































































































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import STextarea from '@/common/components/STextareaShort.vue';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'Queens_Lab4_ReportSheet1',
  components: {
    ChemicalLatex,
    ChemicalNotationInput,
    FileUploadUiComponent,
    TableInput,
    STextarea,
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        crIIIRxn1: null,
        crIIIRxn2: null,
        crIIIRxn3: null,
        crIIIRxn4: null,
        crIII: null,

        coIIRxn1: null,
        coIIRxn2: null,
        coIIRxn3: null,
        coIIRxn4: null,
        coII: null,

        cuIIRxn1: null,
        cuIIRxn2: null,
        cuIIRxn3: null,
        cuIIRxn4: null,
        cuII: null,

        feIIIRxn1: null,
        feIIIRxn2: null,
        feIIIRxn3: null,
        feIIIRxn4: null,
        feIII: null,

        feIIRxn1: null,
        feIIRxn2: null,
        feIIRxn3: null,
        feIIRxn4: null,
        feII: null,

        niIIRxn1: null,
        niIIRxn2: null,
        niIIRxn3: null,
        niIIRxn4: null,
        niII: null,

        cationRxn2: null,
        anionRxn2: null,
        precipitateRxn2: null,

        cationRxn3: null,
        anionRxn3: null,
        precipitateRxn3: null,

        cationRxn4: null,
        anionRxn4: null,
        precipitateRxn4: null,

        cationRxn5: null,
        anionRxn5: null,
        precipitateRxn5: null,

        cationRxn6: null,
        anionRxn6: null,
        precipitateRxn6: null,
      },
      cationOptions: [
        {text: 'Chromium(III)', value: 'chromium3'},
        {text: 'Cobalt(II)', value: 'cobalt2'},
        {text: 'Copper(II)', value: 'copper2'},
        {text: 'Iron(III)', value: 'iron3'},
        {text: 'Iron(II)', value: 'iron2'},
        {text: 'Nickel(II)', value: 'nickel2'},
      ],
      anionOptions: [
        {text: '$\\ce{I^-}$', value: 'iodide'},
        {text: '$\\ce{OH^-/NH3}$', value: 'hydroxideAmmonia'},
        {text: '$\\ce{OH^-/CO3^2-}$', value: 'hydroxideCarbonate'},
        {text: '$\\ce{CrO4^2-}$', value: 'chromate'},
      ],
    };
  },
};
